var link_viewer_default = {
  "fontElementMap": "zPN84",
  "link": "LRZrT",
  "linkInEditor": "_4dOZS",
  "linkInViewer": "z7mqB",
  "toolbarUrlContainer": "NI44M",
  "toolbarUrl": "md0f2",
  "toolbarUrlAnchor": "_2Wt3P"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
